import React, { useState, useEffect } from "react";
import { useGetLandlordPropertyQuery } from "../../lib/apiSlice/property/propertySlice.tsx";
import { Table, Image } from "react-bootstrap";
import { Link } from "react-router-dom";
import jwt_decode from "jwt-decode";
import { serverUrl } from "../../../../serverUrl.js";
import loaderImageGif from "../../../../assets/img/kodi_loader.gif";

export default function PropertyListings() {
  const { data, isLoading } = useGetLandlordPropertyQuery();
  const [currentPage, setCurrentPage] = useState(0);
  const [foundLandlord, setFoundLandlord] = useState(null);
  const itemsPerPage = 5;

  const accessToken = localStorage.getItem("authTokens");
  const parsedTokens = JSON.parse(accessToken);
  const access = parsedTokens.access;
  const config = {
    headers: { Authorization: `Bearer ${access}` },
  };
  const decodedToken = jwt_decode(accessToken);
  const userId = decodedToken.user_id;

  useEffect(() => {
    const fetchLandlord = async () => {
      try {
        const response = await serverUrl.get(`/landlord/landlord/?user_id=${userId}`, config);
        const landlordIds = response.data.results[0];
        setFoundLandlord(landlordIds);
      } catch (error) {
        console.error("Error fetching landlord:", error);
      }
    };

    fetchLandlord();
  }, []);

 if (isLoading) {
    return (
      <div className="flex flex-col justify-center items-center h-screen">
          <img src={loaderImageGif} alt="Loading..." style={{width:"400px"}} />

      </div>
    );
  }

  if (!data?.results || data.results.length === 0) {
    return <p>No properties found</p>;
  }

  const totalPages = Math.ceil(data.results.length / itemsPerPage);
  const startIndex = currentPage * itemsPerPage;
  const endIndex = Math.min(startIndex + itemsPerPage, data.results.length);
  const displayedItems = data.results.slice(startIndex, endIndex);

  const handlePrevPage = () => {
    setCurrentPage((prev) => Math.max(prev - 1, 0));
  };

  const handleNextPage = () => {
    setCurrentPage((prev) => Math.min(prev + 1, totalPages - 1));
  };

  return (
    <div className="tasks">
      <h5 className="float-start">My List of Properties</h5>
      <Table className="table">
        <thead className="">
          <tr>
            <th>Image</th>
            <th>Property</th>
            <th>Units</th>
            <th>Expected Rent</th>
            <th>Occupancy</th>
            {foundLandlord?.can_generate_invoice && <th>Settings</th>}
            <th>Invoicing</th>
            {/* <th>Receipts</th> */}
          </tr>
        </thead>
        <tbody>
          {displayedItems.map((listApartment) => (
            <tr key={listApartment.id}>
              <td>
                <Image
                  src={listApartment.property_image}
                  className="imageTableDashboard"
                  alt={listApartment.name}
                />
              </td>
              <td>
                <Link
                  to={`/selected-property/${listApartment.id}`}
                  className="text-primary text-decoration-underline"
                >
                  {listApartment.name}
                </Link>
              </td>
              <td>{listApartment.num_houses}</td>
              <td>Ksh. {listApartment.expected_rent?.toLocaleString() ?? 0}</td>
              <td>
                <span
                  className={`badge ${listApartment.occupancy < 33
                    ? "bg-danger"
                    : listApartment.occupancy < 67
                      ? "bg-warning"
                      : "bg-success"
                    } p-2`}
                >
                  {listApartment.occupancy || 0}%
                </span>
              </td>
              {foundLandlord?.can_generate_invoice && (
                <td>
                  <Link
                    to={`/property-settings/${listApartment.id}`}
                    className="text-primary text-decoration-underline"
                  >
                    View Property Settings
                  </Link>
                </td>
              )}
              {foundLandlord?.can_edit_invoice_dates && (
                <td>
                  <Link
                    to={`/invoice-updates/${listApartment.id}`}
                    className="text-primary text-decoration-underline"
                  >
                    Invoices Updates
                  </Link>
                </td>
              )}
              <td>
                <Link
                  to={`/invoicing/${listApartment.id}`}
                  className="text-primary text-decoration-underline"
                >
                  View Invoicing
                </Link>
              </td>

              {/* <td>
                <Link
                  to={`/property-receipts/${listApartment.id}`}
                  className="text-primary text-decoration-underline"
                >
                  View Receipts 
                </Link>
              </td> */}
            </tr>
          ))}
        </tbody>
      </Table>

      <div className="pagination">
        <button onClick={handlePrevPage} disabled={currentPage === 0}>
          &lt;
        </button>
        <span>
          {`${startIndex + 1}-${endIndex} of ${data.results.length}`}
        </span>
        <button onClick={handleNextPage} disabled={currentPage >= totalPages - 1}>
          &gt;
        </button>
      </div>
    </div>
  );
}